import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "explore-tab"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]

import { ref, onMounted, computed } from 'vue'
  import PromptCard from './PromptCard.vue'
  import { useAuthStore } from '../stores/auth'
  import { usePromptStore } from '../stores/prompts'
  import Prompt from '@/types/Prompt'
  import PaginatedPrompt from '@/types/PaginatedPrompt'
  import { PrintPhoto } from '@/service/services'

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ExploreTab',
  setup(__props) {

  const loading = ref(true)
  const offset = ref(0)
  const promptStore = usePromptStore()
  const authStore = useAuthStore()

  const isModalOpen = ref(false)
  const selectedPrompt = ref<Prompt | null>(null)

  const prompts = computed<Prompt[]>(() => promptStore.allPrompts?.result ?? [])
  const allPrompts = computed<PaginatedPrompt | undefined>(() => promptStore.allPrompts)

  const getAllPrompts = async () => {
    loading.value = true
    offset.value = 0
    await promptStore.fetchAllPrompts(authStore.session?.access_token ?? '', 0)
    loading.value = false
  }

  const loadMore = async () => {
    offset.value += 10
    await promptStore.fetchAllPrompts(authStore.session?.access_token ?? '', offset.value)
  }

  const openModal = (prompt: Prompt) => {
    selectedPrompt.value = prompt
    isModalOpen.value = true
  }

  const closeModal = () => {
    isModalOpen.value = false
    selectedPrompt.value = null
  }

  const printImage = () => {
    if (selectedPrompt.value?.image_url) {
      PrintPhoto(selectedPrompt.value.image_url)
    }
  }

  const handleDelete = async () => {
    if (!selectedPrompt.value) return
    await promptStore.deletePrompt(selectedPrompt.value.uuid, selectedPrompt.value.image_url)
    closeModal()
    await getAllPrompts()
  }

  onMounted(() => {
    getAllPrompts()
  })


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!loading.value && prompts.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prompts.value, (prompt) => {
            return (_openBlock(), _createBlock(PromptCard, {
              key: prompt.id,
              prompt: prompt,
              onSelect: openModal
            }, null, 8, ["prompt"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (allPrompts.value?.next)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            onClick: loadMore,
            class: "load-button"
          }, "More")
        ]))
      : _createCommentVNode("", true),
    (isModalOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "modal-overlay",
          onClick: closeModal
        }, [
          _createElementVNode("div", {
            class: "modal-content",
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
          }, [
            _createElementVNode("img", {
              src: selectedPrompt.value?.image_url,
              alt: "Full size image",
              class: "modal-image"
            }, null, 8, _hoisted_3),
            _createElementVNode("div", { class: "modal-buttons" }, [
              _createElementVNode("button", {
                onClick: printImage,
                class: "print-btn"
              }, "Print"),
              _createElementVNode("button", {
                onClick: handleDelete,
                class: "delete-btn"
              }, "Delete"),
              _createElementVNode("button", {
                onClick: closeModal,
                class: "close-btn"
              }, "Close")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})